import ReactDOM from 'react-dom';

import { ConfirmationDialog } from '../components/ConfirmationDialog';

export const confirm = (): Promise<boolean> => {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
      resolve(false);
    };

    const handleConfirm = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
      resolve(true);
    };

    ReactDOM.render(<ConfirmationDialog open={true} onClose={handleClose} onConfirm={handleConfirm} />, container);
  });
};
